import { useRef } from "react";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";

export function Parallax({ speed = 0.15, className = "", children, ...rest }) {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [speed * 200, -speed * 200]);
  return <motion.div ref={ref} style={reduce ? undefined : { y }} className={className.includes("absolute") ? className : `relative ${className}`} {...rest}>{children}</motion.div>;
}

export function Reveal({ delay = 0, className = "", children }) {
  const reduce = useReducedMotion();
  return (
    <motion.div className={className} initial={reduce ? false : { opacity: 0, y: 28 }} whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}>
      {children}
    </motion.div>
  );
}

export function useHeroScroll(range) {
  const reduce = useReducedMotion();
  const { scrollY } = useScroll();
  const v = useTransform(scrollY, [0, 700], range);
  return reduce ? 0 : v;
}
